module.exports = __webpack_public_path__ + "static/media/plivo_logo.512e22a7.png";